var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarticondark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90.2 90.2",
    style: {
      enableBackground: "new 0 0 90.2 90.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st1{fill:#010000;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 45.1,
    cy: 45.1,
    r: 45.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.85,49.39c0.24,1.17,0.47,2.31,0.7,3.47c0.09,0,0.17,0,0.26,0c8.18,0,16.36,0,24.54,0 c0.86,0,1.55,0.51,1.78,1.29c0.33,1.15-0.51,2.25-1.75,2.28c-0.13,0-0.26,0-0.39,0c-8.56,0-17.12,0-25.67,0 c-0.61,0-1.16-0.16-1.57-0.64c-0.21-0.24-0.33-0.52-0.4-0.83c-0.64-3.16-1.28-6.32-1.93-9.48c-0.66-3.26-1.32-6.52-1.98-9.78 c-0.55-2.69-1.09-5.37-1.64-8.06c-0.09-0.46-0.1-0.46-0.56-0.46c-3.19,0-6.39,0-9.58,0c-1.05,0-1.85-0.76-1.86-1.77 c-0.01-0.97,0.76-1.76,1.73-1.8c0.06,0,0.12,0,0.18,0c3.79,0,7.57,0,11.36,0c0.99,0,1.68,0.58,1.87,1.54 c0.28,1.41,0.57,2.82,0.85,4.23c0.07,0.32,0.14,0.64,0.19,0.97c0.02,0.13,0.08,0.17,0.2,0.16c0.1-0.01,0.2,0,0.3,0 c11.48,0,22.96,0,34.45,0c0.88,0,1.55,0.47,1.78,1.23c0.11,0.4,0.09,0.79-0.04,1.18c-1.13,3.45-2.26,6.9-3.4,10.35 c-0.5,1.51-0.98,3.02-1.49,4.53c-0.27,0.81-0.84,1.34-1.67,1.55c-0.15,0.04-0.32,0.04-0.48,0.04c-8.5,0-17.01,0-25.51,0 C34.04,49.39,33.96,49.39,33.85,49.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54.72,66.59c-2.15,0.01-3.92-1.75-3.92-3.91c-0.01-2.14,1.74-3.89,3.86-3.92c2.15-0.03,3.93,1.7,3.97,3.83 C58.67,64.68,57.02,66.56,54.72,66.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.84,66.59c-2.18,0-3.91-1.76-3.91-3.97c0-2.13,1.76-3.86,3.94-3.85c2.13,0,3.88,1.76,3.88,3.91 C41.75,64.83,39.99,66.59,37.84,66.59z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarticondark);
export default __webpack_public_path__ + "static/media/carticondark.bcb61c68e818d8cb7b9474e206d13ea0.svg";
export { ForwardRef as ReactComponent };